import {
  APIPresentationScenarioAttributes,
  ArdoqId,
  EnhancedPresentation,
} from '@ardoq/api-types';

export const getScenario = (
  presentationData: EnhancedPresentation | null,
  scenarioId: ArdoqId
): APIPresentationScenarioAttributes | undefined =>
  presentationData?.scenarios.find(s => s._id === scenarioId);
